import {
  ClientSideToolCallSchema,
  ClientSideToolResultSchema,
} from "@redotech/redo-model/agents/client-side-tool-call";
import { MessageSchema } from "@redotech/redo-model/agents/llm-messages";
import * as z from "zod";

// Support frontend agent endpoint
export const supportFrontendAgent = {
  name: "supportFrontendAgent" as const,
  input: z.object({
    threadId: z.string().optional(),
    userMessage: z.string().optional(),
    toolResults: z.array(ClientSideToolResultSchema).optional(),
  }),
  output: z.object({
    threadId: z.string(),
    hasClientSideTools: z.boolean(),
    clientSideTools: z.array(ClientSideToolCallSchema).optional(),
    agentResponse: z.string().optional(),
    messages: z.array(MessageSchema).optional(),
  }),
};
